import { bopApi } from '@/lib/api/client';

export type FuturesAssessmentOutcome = 'FAILED' | 'MANUAL-REVIEW' | 'PASSED';

export interface FuturesAssessmentQuestionExplanation {
  question: string;
  answer: string[];
  points: number;
  /** null for v1, which has no answers schema to work the maximum out from */
  maxPoints: number | null;
}

export interface FuturesAssessmentSectionExplanation {
  section: string;
  questions: string[];
  points: number;
  maxPoints: number | null;
}

export interface FuturesAssessmentExplanation {
  version: string;
  score: number;
  maxScore: number | null;
  /** FAIL is the lowest review score, MANUAL_REVIEW the lowest passing score */
  thresholds: { FAIL: number; MANUAL_REVIEW: number };
  /** The outcome from the score alone, before auto-fail, auto-pass or manual review rules */
  scoreBand: FuturesAssessmentOutcome;
  autoFailed: boolean;
  autoPassed: boolean;
  outcome: FuturesAssessmentOutcome;
  manualReviewReasons: string[];
  questions: FuturesAssessmentQuestionExplanation[];
  sections: FuturesAssessmentSectionExplanation[];
}

export interface FuturesAssessmentAttemptExplanation {
  accountHolderId: string;
  date: string;
  /** status: 0 passed, 1 manual review, 2 failed */
  stored: { score: number; status: number; manualReview?: boolean };
  explanation: FuturesAssessmentExplanation;
  /** False when the stored score or status differs from re-scoring, such as after a reviewer decision */
  matchesStored: boolean;
  /** The attempt was saved without a version, so it was explained as v1 */
  versionInferred: boolean;
}

/** `date` must be the attempt's stored date (`d`) exactly as saved, not the formatted date shown in BOP */
export const getFuturesAssessmentExplanation = async ({ pid, date }: { pid: string; date: string }): Promise<FuturesAssessmentAttemptExplanation> =>
  bopApi.get(`v1/user/${pid}/futures-assessment/explain`, { searchParams: { date } }).json<FuturesAssessmentAttemptExplanation>();
